import Link from 'next/link'
import { Box, Typography } from '@mui/material'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { PartnerPageData } from 'types/types'

export type CrossProductTarget = 'prize-draws' | 'predictor'

const TARGET_CONFIG: Record<
  CrossProductTarget,
  {
    path: string
    heading: string
    sub: string
    accent: string
    logo: string
  }
> = {
  'prize-draws': {
    path: 'prize-draw',
    heading: 'Prize Draws',
    sub: 'Enter draws for a chance to win some amazing prizes',
    accent: '#36E0F6',
    logo: '/tbl_logo_prizedraws.png',
  },
  predictor: {
    path: 'landing',
    heading: 'Predictor',
    sub: 'Play games, climb the leaderboards and win prize draw credit!',
    accent: '#FCAD0E',
    logo: '/tbl_logo_predictor.png',
  },
}

export interface CrossProductCardProps {
  pageTheme: PartnerPageData
  target: CrossProductTarget
}

export const CrossProductCard = ({ pageTheme, target }: CrossProductCardProps) => {
  const { path, heading, sub, accent, logo: logoSrc } = TARGET_CONFIG[target]

  return (
    <Box
      component={Link}
      href={`/${pageTheme.company_domain}/${path}`}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        p: 2,
        borderRadius: '14px',
        background: `linear-gradient(135deg, ${accent} 0%, ${accent}CC 100%)`,
        cursor: 'pointer',
        textDecoration: 'none',
        outline: 'none',
        boxShadow: `0 6px 18px ${accent}4D`,
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: `0 10px 24px ${accent}66`,
        },
        '&:focus-visible': {
          boxShadow: `0 0 0 3px rgba(16,20,24,0.4), 0 10px 24px ${accent}66`,
        },
      }}
    >
      <Box
        sx={{
          width: 44,
          height: 44,
          flexShrink: 0,
          borderRadius: '10px',
          bgcolor: 'rgba(52, 53, 73, 0.45)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          p: 0.75,
        }}
      >
        <Box
          component="img"
          src={logoSrc}
          alt={`${heading} logo`}
          sx={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
        />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography fontWeight={800} fontSize="15px" color="#101418">
          Try {heading}
        </Typography>
        <Typography fontSize="12px" lineHeight={1.35} color="rgba(16,20,24,0.75)">
          {sub}
        </Typography>
      </Box>
      <ArrowForwardIcon sx={{ color: '#101418', flexShrink: 0 }} />
    </Box>
  )
}
